// export const baseUrl = 'http://65.2.100.244/api'
//export const baseUrl = 'http://localhost:8000/api'
// export const baseUrl = 'https://pixel-mortar-app.herokuapp.com/api'
// export const baseUrl = 'https://vendor.pixelandmortar.com/api';
export const baseUrl = process.env.REACT_APP_BACKEND_URL;